import Switch from '@/components/Switch/Switch';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { getAvatarElementFromPage } from '@/pages/AdvancedEditor/utils';
import { useAnalytics } from '@/services/analytics';
import { useFlag } from '@/services/featureFlags';
import { MixPanelEvent } from '@/utils/types';
import styled from '@emotion/styled';
import { Divider } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { ElementType } from 'polotno/model/group-model';
import { ControlRow } from '../../../common/ControlRow';
import { ShadowBlurControl } from './ShadowBlurControl';
import { ShadowColorControl } from './ShadowColorControl';
import { ShadowOffsetControl } from './ShadowOffsetControl';
import { ShadowOpacityControl } from './ShadowOpacityControl';

const ShadowContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const getAvatarShadowProps = (avatar: ElementType) => {
    return {
        shadowBlur: avatar.shadowBlur,
        shadowColor: avatar.shadowColor,
        shadowOffsetX: avatar.shadowOffsetX,
        shadowOffsetY: avatar.shadowOffsetY,
        shadowOpacity: avatar.shadowOpacity,
    };
};

export const ShadowControl = observer(() => {
    const mixpanel = useAnalytics();
    const avatarMaskingShadowEnabled = useFlag('avatar_masking_shadow_enabled', false);
    const { store } = useAdvancedEditorContext();
    const avatarElement = getAvatarElementFromPage(store.activePage);

    if (!avatarElement) return null;

    if (!avatarMaskingShadowEnabled) return null;

    const handleSwitchChange = (_: any, checked: boolean) => {
        mixpanel?.track('avatar-masking', { event: MixPanelEvent.CLICK, ['avatar-masking-shadow']: checked ? 'applied' : 'not-applied' });
        avatarElement.set({ shadowEnabled: checked });
    };

    return (
        <>
            <ShadowContainer>
                <ControlRow>
                    Shadow
                    <Switch checked={avatarElement.shadowEnabled} onChange={handleSwitchChange} />
                </ControlRow>

                {avatarElement.shadowEnabled && (
                    <>
                        <ShadowColorControl />

                        <ControlRow>
                            Offset X
                            <ShadowOffsetControl shadowOffsetField="shadowOffsetX" />
                        </ControlRow>

                        <ControlRow>
                            Offset Y
                            <ShadowOffsetControl shadowOffsetField="shadowOffsetY" />
                        </ControlRow>

                        <ControlRow>
                            Opacity
                            <ShadowOpacityControl />
                        </ControlRow>

                        <ControlRow>
                            Blur
                            <ShadowBlurControl />
                        </ControlRow>
                    </>
                )}
            </ShadowContainer>
            <Divider />
        </>
    );
});
